import { getList, getSelectList, getOne } from './getData'
import { setCreate, setDelete, setUpdate, acceptInvitation } from './setData'

const teams = {
  namespaced: true,
  state: {
    loading: false,
    listTeams: [],
    listSelectTeams: [],
    idSelected: '',
    entitySelect: '',
    teamSelected: {}
  },
  mutations: {
    updateList: (state, list) => {
      state.listTeams = list || []
    },
    updateSelectList: (state, list) => {
      state.listSelectTeams = []
      if (Array.isArray(list)) {
        list.forEach(item => state.listSelectTeams.push(item))
      }
    },
    updateEntity: (state, entity) => {
      state.entitySelect = entity
    },
    updateOne: (state, one) => {
      state.teamSelected = one
      state.idSelected = one._id
    },
    updateLoading: (state, loading) => {
      state.loading = loading || false
    },
    updateClearOne: state => {
      state.teamSelected = {}
      state.idSelected = ''
      state.entitySelect = ''
    }
  },
  actions: {
    setInit: async ({ commit }) => {
      await getList(commit)
    },
    setInitSelect: (context, payload = {}) => getSelectList(context, payload),
    setCreateNew: async ({ commit }, { idEntity, team }) => {
      await setCreate(idEntity, team)
      getList(commit)
    },
    setUpdateTeam: async ({ commit }, { idEntity, team }) => {
      await setUpdate(idEntity, team)
      getList(commit)
    },
    setDeleteTeam: async ({ commit }, { idEntity, idTeam }) => {
      await setDelete(idEntity, idTeam)
      getList(commit)
    },
    acceptInvitation: async ({ commit }, payload) => {
      const message = await acceptInvitation(payload)
      return message
    },
    setOne: ({ commit }, { idEntity, idTeam }) =>
      getOne(commit, idEntity, idTeam),
    setClearOne: ({ commit }) => {
      commit('updateClearOne')
    },
    setEntity: ({ commit }, entity) => commit('updateEntity', entity)
  }
}

export default teams
